import { GET_LIST_ITEMS_ERROR, GET_LIST_ITEMS_START, GET_LIST_ITEMS_SUCCESS } from '../../types';

export default function get_list_items(state, action) {
  switch (action.type) {
    case GET_LIST_ITEMS_START:
      return { ...state };
    case GET_LIST_ITEMS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_LIST_ITEMS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
